import { render, staticRenderFns } from "./Dashboard_pagination.vue?vue&type=template&id=aa7adf78&scoped=true&"
import script from "./Dashboard_pagination.vue?vue&type=script&lang=js&"
export * from "./Dashboard_pagination.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard_pagination.vue?vue&type=style&index=0&id=aa7adf78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7adf78",
  null
  
)

export default component.exports